<script setup lang="ts">
    import { useSqlEditorStore } from '@/stores/sqlEditorStore';
    import { computed } from 'vue';
    const store = useSqlEditorStore();

    function getParameterIssueMessage(parameterName: string): string | undefined {
        switch (parameterName.toLowerCase()) {
            case 'query':
            case 'title':
            case 'pagesize':
                return `Parameter name "${parameterName}" is reserved, and should not be used if you intend to share a link to this query!`;
        }
    }

    const parameterIssues = computed(() => {
        const result: Record<string, string | undefined> = {};
        store.loadedQueryParameters.forEach(p => {
            result[p.name] = getParameterIssueMessage(p.name);
        });
        return result;
    });
</script>

<template>
    <b-field
        v-for="p in store.loadedQueryParameters"
        :key="p.name"
        :type="parameterIssues[p.name] ? 'is-warning' : null"
        :message="parameterIssues[p.name]"
        :label="`@${p.name}:`">
        <b-input
            v-model="p.stringValue"
            expanded />
    </b-field>
    <p class="block">
        Provide parameter values in order to run the query, export to Excel, or share a result link.
    </p>
</template>
